import { useTranslation } from 'react-i18next';
import Button from '../core/button/CoreButton';
import PageBannerCard from '../core/card/PageBannerCard';
import ActivateLicenseMinorCTA from './ActivateLicenseMinorCTA';

export interface ILicenseExpiredBannerCardProps {
    canManageBilling: boolean;
    organizationId: string;
}

export default function LicenseExpiredBannerCard({ canManageBilling, organizationId }: ILicenseExpiredBannerCardProps) {
    const { t } = useTranslation();
    return (
        <PageBannerCard
            icon="cancel"
            fullHeight
            title={t('common:organization.expired.title')}
            description={
                canManageBilling ? t('common:organization.expired.admin') : t('common:organization.expired.user')
            }>
            {canManageBilling && (
                <>
                    <Button href={`#/org/${organizationId}/billing/redirect/upgrade`} endIcon="externalLink">
                        {t('common:billing.view')}
                    </Button>
                    <ActivateLicenseMinorCTA organizationId={organizationId} />
                </>
            )}
        </PageBannerCard>
    );
}
